import React from 'react';
import Nav from 'react-bootstrap/Nav';
import { useNavigate } from 'react-router-dom';

import { useFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';

const SignOutButton = ({ onNavigate }) => {
  const firebase = useFirebase();
  const navigate = useNavigate();

  return (
    <Nav.Link
      className="nav-link js-scroll-trigger"
      href={ROUTES.SIGN_IN}
      onClick={(event) => {
        event.preventDefault();
        onNavigate?.();
        firebase.doSignOut();
        navigate(ROUTES.SIGN_IN, { replace: true });
      }}
    >
      Sign Out
    </Nav.Link>
  );
};

export default SignOutButton;
